import { ContactDetailsContact } from '../../api/teamRelationship'
import { TeamMember } from './types'

const EMPTY_MEMBER_METRICS: TeamMember['metrics'] = {
  closedWon: { count: 0, amount: 0 },
  inProgress: { count: 0, amount: 0 },
}

export const mapContactDetailsToTeamMember = (
  contact: ContactDetailsContact
): TeamMember => {
  const engagedWith = (contact.engagedWith ?? [])
    .map(person => (person.name ?? '').trim())
    .filter(Boolean)

  return {
    id: contact.contactId,
    name: (contact.contactName ?? '').trim() || '-',
    role: (contact.title ?? '').trim() || '-',
    location: contact.location ?? '',
    avatarUrl: contact.profileImageUrl,
    engagedWith,
    metrics: EMPTY_MEMBER_METRICS,
    lastActivity: null,
  }
}

export const mapContactDetailsToTeamMembers = (
  contacts: ContactDetailsContact[]
): TeamMember[] =>
  contacts
    .filter(contact => Boolean(contact?.contactId))
    .map(mapContactDetailsToTeamMember)
